var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainImgVisualHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 272,
    height: 418,
    viewBox: "0 0 272 418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_107",
    "data-name": "\\uC0AC\\uAC01\\uD615 107",
    width: 272,
    height: 418,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-main_img_visual.png_hover"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 418
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_img_visual.png_hover",
    "data-name": "main_img_visual.png hover",
    clipPath: "url(#clip-main_img_visual.png_hover)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_3",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 3",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_304",
    "data-name": "\\uADF8\\uB8F9 304"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_96",
    "data-name": "\\uC0AC\\uAC01\\uD615 96",
    width: 272,
    height: 418,
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_262",
    "data-name": "\\uADF8\\uB8F9 262",
    transform: "translate(4968.67 -2563.223)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_49",
    "data-name": "\\uD0C0\\uC6D0 49",
    cx: 100.665,
    cy: 19.211,
    rx: 100.665,
    ry: 19.211,
    transform: "translate(-4898.001 2942.801)",
    fill: "#ecdf19"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_220",
    "data-name": "\\uADF8\\uB8F9 220",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -4969.708, 2609.717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_219",
    "data-name": "\\uADF8\\uB8F9 219"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_161",
    "data-name": "\\uD328\\uC2A4 161",
    d: "M838.892,413.783V390.392H734.3v23.391a53.22,53.22,0,0,0-39.065,51.273V678.287A29.663,29.663,0,0,0,724.9,707.951h123.4a29.663,29.663,0,0,0,29.663-29.663V465.056A53.22,53.22,0,0,0,838.892,413.783Z",
    transform: "translate(-695.235 -334.946)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_89",
    "data-name": "\\uC0AC\\uAC01\\uD615 89",
    width: 182.722,
    height: 199.191,
    transform: "translate(0 137.895)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_90",
    "data-name": "\\uC0AC\\uAC01\\uD615 90",
    width: 146.178,
    height: 65.528,
    rx: 18.966,
    transform: "translate(18.272)",
    fill: "#fff",
    stroke: "#161619",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_162",
    "data-name": "\\uD328\\uC2A4 162",
    d: "M903.2,547.891c-1.978-1.978-5.306-2.246-9.124-1.082a6.78,6.78,0,0,0-1.773-5.035c-4.084-4.083-13.909-.878-21.946,7.159S859.119,566.8,863.2,570.879c1.979,1.979,5.306,2.247,9.124,1.082A6.783,6.783,0,0,0,874.1,577c4.084,4.084,13.909.878,21.947-7.159S907.289,551.974,903.2,547.891Z",
    transform: "translate(-739.608 -374.891)",
    fill: "#ecdf19"
  }), /*#__PURE__*/React.createElement("text", {
    id: "VISUAL_DESIGN",
    "data-name": "VISUAL DESIGN",
    transform: "translate(23.814 255.463)",
    fill: "#161619",
    fontSize: 24,
    fontFamily: "Orbitron-Bold, Orbitron",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VISUAL"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 29
  }, "DESIGN")))))), /*#__PURE__*/React.createElement("text", {
    id: "BX_Contents_Graphic",
    "data-name": "BX / Contents / Graphic",
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 108.937, 355.462)",
    fill: "#ada300",
    fontSize: 12,
    fontFamily: "NotoSans-Regular, Noto Sans"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BX / Contents / Graphic")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainImgVisualHover);
export default __webpack_public_path__ + "static/media/main_img_visual_hover.169f599c8110742ab08fdceebefb5f61.svg";
export { ForwardRef as ReactComponent };